import { Axios } from '../axiosInstance';

const axiosInstance = Axios();

const summaryManager = {
  getSummary(url: any) {
    return axiosInstance.v2({
      url: url,
      method: 'GET'
    });
  }
};

export default summaryManager;
